import useFeatureFlag from "storefront/hooks/data/useFeatureFlag";
import useData from "storefront/hooks/data/useData";
import { Feature } from "storefront/GrailedAPI/v1/Users/Flipper/Feature";
import usePublicConfig from "storefront/hooks/usePublicConfig";
import useAuthentication from "storefront/hooks/useAuthentication";
import createUserRestrictedClient from "storefront/Algolia/Client/createUserRestrictedClient";
import { UserSelf } from "storefront/User";

const fetchHasExpiredListings = async (
  appId: string,
  env: string,
  user: UserSelf,
): Promise<boolean> => {
  const client = await createUserRestrictedClient(appId, user);
  const index = client.initIndex(`Listing_my_items_${env}`);
  const response = await index.search("", {
    filters: "expired:true",
    hitsPerPage: 0,
    analytics: false,
  });
  return response.nbHits > 0;
};

const useHasExpiredListings = (): boolean => {
  const flagResource = useFeatureFlag(Feature.EXPIRED_LISTINGS);
  const config = usePublicConfig();
  const auth = useAuthentication();

  const isEnabled =
    flagResource.type === "Completed" && flagResource.value === true;
  const isAuthenticated = auth.type === "Authenticated";

  const resource = useData(fetchHasExpiredListings, {
    key: "has-expired-listings",
    shouldFetch: isEnabled && isAuthenticated,
    args: isAuthenticated
      ? [config.algolia.appId, config.env, auth.user]
      : undefined,
  });

  if (resource.type === "Completed") return resource.value;
  return false;
};

export default useHasExpiredListings;
